import type { GetStaticProps } from "next";
import type { ReactElement } from "react";
import safeJsonStringify from "safe-json-stringify";
import { NoteSectionLayout } from "@/components/layouts";
import { NotesPageSeo } from "@/components/PageSeo";
import { prismaClient } from "@/lib/prisma-client";
import { bazResolver } from "@/lib/server-queries";

interface MotesPageProps {
  data: Awaited<ReturnType<typeof bazResolver>>;
}

const MotesPage = () => <NotesPageSeo />;

MotesPage.getLayout = function getLayout(page: ReactElement<MotesPageProps>) {
  return <NoteSectionLayout initialData={page.props.data}>{page}</NoteSectionLayout>;
};

export const getStaticProps: GetStaticProps<MotesPageProps> = async () => {
  // Use env variable to switch between hardcoded sample data and DB data (eg. during dev).
  // process.env?.DATA_SOURCE == "prisma"

  // !! update resolver when done
  const data = await bazResolver({}, {}, { prisma: prismaClient });

  return {
    props: {
      data: JSON.parse(safeJsonStringify(data)),
    },
    revalidate: 3600, // 60 * 60 seconds
  };
};

export default MotesPage;
